import React from 'react';
import PropTypes from 'prop-types';
import styles from './dragAndDropInteraction.scss';

class AssociableHotspot extends React.PureComponent {
    static propTypes = {
        correctResponses: PropTypes.array,
        dimensions: PropTypes.array.isRequired,
        identifier: PropTypes.string.isRequired,
        idPrefix: PropTypes.string.isRequired,
        model: PropTypes.object.isRequired,
    };

    shouldMarkAsCorrect(identifier, correctResponses) {
        return correctResponses && correctResponses.find((correctPair) => {
            return correctPair.split(' ')[1] === identifier;
        });
    }

    render() {
        const { correctResponses, dimensions, identifier, idPrefix, model } = this.props;
        const markAsCorrect = this.shouldMarkAsCorrect(identifier, correctResponses);
        const className = `${styles.dropZone} drop${model.markHotspots ? ' mark' : ''}${markAsCorrect ? ' markcorrect' : ''}`;

        return (
            <div
                className={className}
                data-type="drop"
                data-identifier={identifier}
                id={`${idPrefix}-ASSOCIABLE_HOTSPOT-${identifier}`}
                ref={(element) => { this.rootElement = element; }}
                style={{
                    left: `${dimensions[0]}px`,
                    top: `${dimensions[1]}px`,
                    height: `${dimensions[3] - dimensions[1]}px`,
                    width: dimensions[2] - dimensions[0],
                }}
            />
        );
    }
}

export default AssociableHotspot;
